<script>
	/**
	 * This is a modal that user should see if they are logging in with
	 * a migrated Drupal account for the first time, IF they don't have
	 * both a first and last name already in their account.
	 */

	const page = require('page');
	const userContext = require('core/userContext');
	const accountService = require('services/accountService');
	const utilities = require('../utilities');
	const pubsub = require('events/pubsub');

	module.exports = {
		components: {
			modal: require('./modal.vue').default,
			'form-submitter': require('components/form-submitter.vue').default
		},
		mounted() {
			let self = this;
			self.$subscribe('modal-opened', function (modalId, opts) {
				if (modalId !== 'drupal-name-modal') {
					return true; // let some other handler take this
				}

				// Need email and password to retry login route
				if (opts.email && opts.password) {
					userContext.reset(); // Ensure account is not authorized
					self.email = opts.email || '';
					self.password = opts.password || '';
					self.firstName = opts.f || '';
					self.lastName = opts.l || '';
				} else {
					// If email and password aren't provided,
					// we can't complete this form
					// so send them back to login.
					page('/#login');
				}

				return false;
			});

			pubsub.subscribe('submit-succeeded', function (evData) {
				if (evData.formName === 'drupalNameForm') {
					pubsub.publish('logged-in');
					// If you've used this form to log in
					// you are definitely an initial Drupal migratee
					// so ask them for their details
					page.redirect('/my-account#!myAccountTab:about/');
				}

				return true;
			});
		},
		methods: {
			// retry log in route with new info
			submitInfo: function () {
				let self = this;
				let data = {
					email: self.email,
					password: self.password,
					firstName: self.firstName,
					lastName: self.lastName
				};

				return accountService
					.teacherSignIn(data)
					.then(function (result) {
						userContext.initialize(result);

						utilities.closeModals();

						return result;
					})
					.catch(function (err) {
						page('/#login');
					});
			}
		},
		data: function () {
			return {
				email: null,
				password: null,
				firstName: null,
				lastName: null,
				drupalNameForm: {
					allValid: false
				}
			};
		}
	};
</script>
<template>
	<modal
		ref="modal"
		id="drupal-name-modal"
		:ok="false"
		:closeable="false">
		<template slot="header-container">
			<h2>Welcome!</h2>
			<p class="font-small signup-subheader">- from the ReadWorks Team</p>
		</template>
		<template slot="content">
			<form-submitter
				class="form"
				novalidate
				:submit-to="submitInfo"
				form-name="drupalNameForm"
				:form-data.sync="drupalNameForm">
				<p class="form-instructions">To continue, please update your information.</p>
				<div class="form-row">
					<div class="form-input">
						<auto-form-row
							type="firstName"
							row-class="label-hidden-visually"
							placeholder="First Name"
							v-bind:data.sync="firstName"
							required>
						</auto-form-row>
					</div>
					<br />
					<div class="form-input">
						<auto-form-row
							type="lastName"
							row-class="label-hidden-visually"
							placeholder="Last Name"
							v-bind:data.sync="lastName"
							required>
						</auto-form-row>
					</div>
				</div>
				<auto-form-row
					v-bind:all-valid="drupalNameForm.allValid"
					row-class="-full-width"
					type="submit">
					I'm Done
				</auto-form-row>
			</form-submitter>
		</template>
	</modal>
</template>
<style scoped lang="scss">
	@import 'config/colors';
	p.form-instructions {
		text-align: center;
	}

	p.font-small {
		font-weight: normal;
		text-align: center;
		&.signup-subheader {
			margin: 0.5rem 0rem 0rem 0rem;
		}
	}
</style>
